<template>

  <v-layout align-center row wrap>

    <v-flex xs12 class="py-1">
      <div class="field-label">*{{ nameField.label }}</div>
      <v-text-field
        v-model="address.name"
        :label="nameField.placeholder"
        hide-details
        solo
        flat
      ></v-text-field>
    </v-flex>

    <v-flex xs12 class="py-1" v-if="hotelField">
      <div class="field-label">*Hotel Name</div>
      <v-text-field
        v-model="address.hotel"
        hide-details
        solo
        flat
      ></v-text-field>
    </v-flex>

    <v-flex xs12 class="py-1" v-if="hostField">
      <div class="field-label">*Host Name</div>
      <v-text-field
        v-model="address.hotel"
        label="Ex: Name of the host who lives at the address"
        hide-details
        solo
        flat
      ></v-text-field>
    </v-flex>

    <v-flex xs12 class="py-1">
      <div class="field-label">*Street Address</div>
      <v-text-field
        v-model="address.street_address"
        hide-details
        solo
        flat
      ></v-text-field>
    </v-flex>

    <v-flex xs12 class="py-1">
      <div class="field-label">*City</div>
      <v-text-field
        v-model="address.city"
        hide-details
        solo
        flat
      ></v-text-field>
    </v-flex>

    <v-flex xs6 class="py-1">
      <div class="field-label">*State</div>
      <state-select
        :prefill="address.state"
        @on-change="updateState"
      ></state-select>
    </v-flex>

    <v-flex xs6 class="py-1">
      <div class="field-label">*Zipcode</div>
      <v-text-field
        v-model="address.zip"
        hide-details
        solo
        flat
        @keydown="checkZipKeydown"
      ></v-text-field>
    </v-flex>

    <v-flex xs6 class="py-1">
      <div class="field-label">*{{ checkInField }}</div>

      <v-dialog
        ref="checkinDialog"
        v-model="checkinDialog"
        :return-value.sync="address.date_start"
        persistent
        lazy
        full-width
        width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="address.date_start"
            hide-details
            solo
            flat
            append-icon="far fa-calendar"
            readonly
            v-on="on"
            
            @click:append="checkinDialog = true"
          ></v-text-field>
        </template>
        <v-date-picker 
          v-model="address.date_start" 
          scrollable 
          color="primary"
          :min="$moment().add(7,'days').format('YYYY-MM-DD')"
          :picker-date.sync="initialStartDate"
          @input="initialEndDate = address.date_start"
        >
          <v-spacer></v-spacer>
          <v-btn flat color="primary" @click="checkinDialog = false">Cancel</v-btn>
          <v-btn flat color="primary" @click="$refs.checkinDialog.save(address.date_start)">OK</v-btn>
        </v-date-picker>
      </v-dialog>

      
    </v-flex>

    <v-flex xs6 class="py-1">
      <div class="field-label">*{{ checkOutField }}</div>
      <v-dialog
        ref="checkoutDialog"
        v-model="checkoutDialog"
        :return-value.sync="address.date_end"
        persistent
        lazy
        full-width
        width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="address.date_end"
            hide-details
            solo
            flat
            append-icon="far fa-calendar"
            readonly
            v-on="on"
            @click:append="checkoutDialog = true"
          ></v-text-field>
        </template>
        <v-date-picker 
          v-model="address.date_end" 
          scrollable 
          color="primary"
          :min="(address.date_start || $moment().add(7,'days').format('YYYY-MM-DD'))"
          :picker-date.sync="initialEndDate"
        >
          <v-spacer></v-spacer>
          <v-btn flat color="primary" @click="checkoutDialog = false">Cancel</v-btn>
          <v-btn flat color="primary" @click="$refs.checkoutDialog.save(address.date_end)">OK</v-btn>
        </v-date-picker>
      </v-dialog>
    </v-flex>

    <template v-if="travelLocation">
      <v-flex xs12 class="pt-5 pb-2">
        <div class="field-label text-xs-center"><h5>I'm traveling to...</h5></div>
      </v-flex>
      <v-flex xs6 class="py-1">
        <div class="field-label">*City</div>
        <v-text-field
          v-model="address.travel_city"
          hide-details
          solo
          flat
        ></v-text-field>
      </v-flex>

      <v-flex xs6 class="py-1">
        <div class="field-label">*State/Province</div>
        <v-text-field
          v-model="address.travel_state"
          hide-details
          solo
          flat
        ></v-text-field>
      </v-flex>

      <v-flex xs12 class="py-1">
        <div class="field-label">*Country</div>
        <country-select
          :prefill="address.travel_country"
          @on-change="updateCountry"
        ></country-select>
      </v-flex>
    </template>
    
  </v-layout>

</template>

<script>
import CountrySelect from '@/components/helpers/CountrySelect';
import StateSelect from '@/components/helpers/StateSelect';

export default {
  props: {
    prefill: Object,
    nameField: {
      type: Object,
      default: function() {
        return { label: 'Name', placeholder: '' };
      }
    },
    checkInField: {
      type: String,
      default: 'Check In'
    },
    checkOutField: {
      type: String,
      default: 'Check Out'
    },
    hotelField: Boolean,
    hostField: Boolean,
    travelLocation: Boolean
  },
  components: {
    'state-select': StateSelect,
    'country-select': CountrySelect
  },
  name: 'AddressContainer',
  data () {
    return {
      address: {
        name: (this.prefill ? this.prefill.name : null),
        hotel: (this.prefill ? this.prefill.hotel : null),
        street_address: (this.prefill ? this.prefill.street_address : null),
        city: (this.prefill ? this.prefill.city : null),
        state: (this.prefill ? this.prefill.state : null),
        zip: (this.prefill ? this.prefill.zip : null),
        date_start: (this.prefill ? this.prefill.date_start : null),
        date_end: (this.prefill ? this.prefill.date_end : null),
        travel_city: (this.prefill ? this.prefill.travel_city : null),
        travel_state: (this.prefill ? this.prefill.travel_state : null),
        travel_country: (this.prefill ? this.prefill.travel_country : null)
      },

      checkinDialog: false,
      checkoutDialog: false,

      initialStartDate: this.$moment().add(7,'days').format('YYYY-MM-DD'),
      initialEndDate: this.$moment().add(7, 'days').format('YYYY-MM-DD'),

    }
  },
  watch: {
    address: {
      handler: function(newVal, oldVal) {
        this.$emit('on-update', this.address);
      },
      deep: true
    },
    'address.date_start': function(newVal, oldVal) {
      if(newVal && this.address.date_end && this.address.date_end < newVal) this.$set(this.address, 'date_end', newVal);
    }
  },
  computed: {
    
  },
  methods: {
    checkZipKeydown: function(e) {
      if(e.key == 'Tab') this.checkinDialog = true;
    },
    updateState: function(state) {
      this.$set(this.address, 'state', state);
    },
    updateCountry: function(val) {
      this.$set(this.address, 'travel_country', val);
    },
  }
}
</script>